import React, { Component } from 'react';
import { connect } from 'react-redux';
import range from 'lodash/range';
import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import includes from 'lodash/includes';
import {
	Card,
	Button,
	CardImg,
	CardTitle,
	CardBody,
	Alert,
	Form,
	FormGroup,
	Input,
	Modal,
	ModalHeader,
	ModalBody,
	Media } from 'reactstrap';
import { push } from 'connected-react-router';
import ReactTable from 'react-table';
import {
	fetchApps,
	filteringApps,
	uploadNewApk,
	localGetSelectedApps,
	localSaveSelectedApps,
	fetchCheckedAppsInfo,
	getInRetailAppsList,
	saveInRetailAppsList
} from '../../actions/marketActions';

import { closeAlert } from '../../actions/commonsActions';
import {
	API_BASE_URL,
	GUEST,
	SUPER_ADMIN,
	PAGINATION_LIST_SIZE,
	PAGINATION_DEFAULT_LIMIT,
	COMPANY_ADMIN,
	MARKETVIEW,
	BLOCKED,
	NOT_APPROVED, ACTIVE
} from '../../helpers/constants';
import {I18n} from '../../I18n/components/market';

import 'react-table/react-table.css';
import './market.css';
import spinner from '../../assets/images/spinner.gif';
import PaginationList from '../PaginationList/PaginationList';
import CheckedAppsList from '../CheckedAppsList/CheckedAppsList';
import {inRetailAppsList} from '../../reducers/market';
import Application from '../../components/Application/Application';
import Pagination from '../Pagination/Pagination';
import profilephoto from "../../assets/images/users/1.jpg";
import {fetchCompanies} from "../../actions/companyActions";

class Market extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoadingApps: false,
			uploadModal: false,
			uploadApkName: "Выбор файла",
			uploadApk: null,
			isApkUpload: false,
			currentPage: 0,
			paginatedList: [],
			prev_filters: [],
			active_filters:[],
			checkedApps: [],
			selectedAppModal: false,
			isOkViewAppModal: false,
			activePage: 0,

			uploadMessage: null,
			uploadComment: null,
		};
	}

	componentDidMount() {
		this.mounted = true;
		this.setState({
			isLoadingApps: true
		});
		this.props.fetchApps()
			.then(async () => {
				if(this.mounted) {
					if (!this.props.company) {
						await this.props.fetchCompanies()
					}
					await this.props.getInRetailAppsList(this.props.company.id, this.getAppsPackageNameList());
					this.setState({
						isLoadingApps: false,
						paginatedList: this.props.pagination.totalPages > PAGINATION_LIST_SIZE ?
							range(0, PAGINATION_LIST_SIZE) : range(0, this.props.pagination.totalPages),
						// currentPage: this.props.currentPage
					});
				}
			});
		this.props.localGetSelectedApps().then(() => {
			this.setState({
				checkedApps: this.props.checkedApps
			})
		});
	}

	componentWillMount() {
		this.mounted = false;
	}

	onFilterClick =  event => {
		const value = event.target.value;
		this.setState({
			activePage: 0
		}, () => {
			this.props.filteringApps(value);
		})
	};

	toggleUploadModal = () => {
		this.setState({
			uploadModal: !this.state.uploadModal,
			uploadApkName: null,
			uploadApk: null,
			uploadMessage: null,
			uploadComment: null
		});
	};

	closeUploadModal = () => {
		this.setState({
			uploadModal: !this.state.uploadModal,
			isApkUpload: false,
			uploadMessage: null,
			uploadComment: null
		});
	};

	uploadApkClick = () => {
		this.toggleUploadModal();
	};

	onFileSelect = event => {
		this.setState({
			uploadMessage: null,
			uploadComment: null
		});
		let names = '';
		const uploadedFiles = [];
		if (event.target.files.length) {
			[].forEach.call(event.target.files,f => {
				const data = new FormData();
				data.append('file', f);
				data.append('filename', f.name);
				names = names + ` ${f.name}`;
				uploadedFiles.push(data);
			});
			//data.append('file', event.target.files[0]);
			//data.append('filename', event.target.files[0].name);

			this.setState({
				//uploadApkName: event.target.files[0].name,
				//uploadApk: data,
				uploadApkName: names,
				uploadApk: uploadedFiles,
			})
		}

	};

	sendFile = event => {
		event.preventDefault();
		this.setState({
			uploadMessage: null,
			uploadComment: null
		});
		if (this.state.uploadApk) {
			this.setState({
				isApkUpload: true
			});
			this.props.uploadNewApk(this.state.uploadApk)
				.then(res => {
					this.setState({
						uploadApk: null,
						uploadApkName: null,
						isApkUpload: false,
						uploadMessage: res.message,
						uploadComment: res.comment
					});
					this.props.fetchApps(true);
				})
		}
	};

	fetchPaginatedData = async (currentPage) => {
		if (!this.state.active_filters) {
			this.setState({
				currentPage
			});
			await this.props.fetchApps({ page: currentPage });
			await this.props.getInRetailAppsList(this.props.company.id, this.getAppsPackageNameList());
		} else {
			if (isEqual(sortBy(this.state.active_filters), sortBy(this.state.prev_filters))) {
				await this.props.fetchApps({
					filters: this.state.active_filters.join(','),
					page: currentPage
				});
				await this.props.getInRetailAppsList(this.props.company.id, this.getAppsPackageNameList());
				this.setState({
					currentPage
				});
			} else {
				await this.props.fetchApps({
					filters: this.state.active_filters.join(','),
				});
				await this.props.getInRetailAppsList(this.props.company.id, this.getAppsPackageNameList());
				this.setState(state => ({
					currentPage: 0,
					rev_filters: state.active_filters
				}));
			}
		}
	};

	setPaginatedList = paginatedList => {
		this.setState({
			paginatedList
		})
	};

	setCurrentPage = currentPage => {
		this.setState({
			currentPage
		});
		this.fetchPaginatedData(currentPage)
	};

	checkedApp = appId => {
		if (!includes(this.state.checkedApps, appId)) {
			this.setState(state => ({
				checkedApps: [...state.checkedApps, appId]
			}), () => {
				this.props.localSaveSelectedApps(this.state.checkedApps);
			});
		}
	};

	uncheckedApp = appId => {
		const items = this.state.checkedApps;
		const index = items.indexOf(appId);
		if (index > -1) {
			items.splice(index, 1);
			this.setState({
				checkedApps: items
			},() => {
				this.props.localSaveSelectedApps(this.state.checkedApps);
			});
		}
	};

	uncheckedAllApps = () => {
		this.setState({
			checkedApps: []
		},() => {
			this.props.localSaveSelectedApps(this.state.checkedApps);
		});
	};

	sendCheckedApps = () => {
		if (this.state.checkedApps.length) {
			this.props.saveInRetailAppsList(this.props.company.id, this.state.checkedApps).then(() => {
				this.uncheckedAllApps();
				this.toggleSelectedAppModal();
				this.fetchPaginatedData();
			});
		}
	};

	isAppSelected = appId => includes(this.state.checkedApps, appId);

	isInLocalMarket = packageName => includes(this.props.inRetailAppsList, packageName);

	toggleSelectedAppModal = () => {
		if (!this.state.selectedAppModal) {
			this.props.fetchCheckedAppsInfo(this.state.checkedApps)
				.then(() => {
					this.setState({
						selectedAppModal: !this.state.selectedAppModal
					});
				});
		} else {
			this.setState({
				selectedAppModal: !this.state.selectedAppModal
			});
		}
	};

	isOkViewAppModalToggle = id => {
		if (id) {
			this.setState(state => ({
				activeAppId : id,
				isOkViewAppModal: !state.isOkViewAppModal
			}));
		} else {
			this.setState(state => ({
				activeAppId : null,
				isOkViewAppModal: !state.isOkViewAppModal
			}));
		}
	};

	getAppsPackageNameList = () => (this.props.apps.map(app => app.packageName));

	onPageChange = page => {
		this.setState({
			activePage: page
		})
	};

	createPaginatedData = apps => {
		const pageSize = PAGINATION_DEFAULT_LIMIT;
		const upperLimit = (this.state.activePage + 1) * pageSize;
		const dataSlice = apps.slice((upperLimit - pageSize), upperLimit);
		return dataSlice;
	};

	generateAppsList = apps => {
		const paginatedData = this.createPaginatedData(apps);
		return paginatedData.map(item => {
			return (
				<Card
					className="market-item"
					key={item.id}
					onClick={() => {this.isOkViewAppModalToggle(item.id)}}
					//onClick={() => {this.props.changeLocation(`/dashboard/market/${item.id}`)}}
				>
					<div className="market-item__img-wrapper"  style={item.id ? {background: 'none'} : {}}>
						<CardImg top width="10%"
								 className="market-item__image"
								 alt="application logotype"
								 src={`${API_BASE_URL}/apps/mobileapps/download/icon/${item.id}`}/>
					</div>
					<CardBody>
						<CardTitle>{item.appLabel}</CardTitle>
					</CardBody>
					{
						(() => {
							if (this.props.authority === COMPANY_ADMIN) {
								return (
									this.isInLocalMarket(item.packageName) ? (
										<i className="market-item__added ml-3 badge badge-light badge-pill">Добавлен</i>
									) : !this.isAppSelected(item.id) ? (
										<button
											className="market-item__add btn btn-circle btn-sm btn-info float-right text-white"
											onClick={event => {
												event.stopPropagation();
												this.checkedApp(item.id);
											}}
										>
											<i className="fas fa-plus"></i>
										</button>
									) : (
										<button
											className="market-item__add btn btn-circle btn-sm btn-success float-right text-white"
											onClick={event => {
												event.stopPropagation();
												this.uncheckedApp(item.id);
											}}
										>
											<i className="fas fa-check"></i>
										</button>
									)
								)
							}
						})()
					}

				</Card>
			)
		});
	};

	render() {
		const {lang} = this.props;
		return (
			<div>
				{/*----------------------- alerts -----------------------------------*/}
				<Alert
					color={`${this.props.alert.alert.status}`}
					isOpen={this.props.alert.isOpen || false}
				>
					{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
				</Alert>
				<Modal className="upload-modal" isOpen={this.state.uploadModal} toggle={this.toggleUploadModal}>
					<ModalHeader toggle={this.toggle}>{I18n[lang].downloadApk.title}</ModalHeader>
					<ModalBody>
						<Form onSubmit={this.sendFile}>
							<FormGroup className="mb-1">
								<div className="custom-file">
									<Input
										type="file"
										className="custom-file-input"
										id="upload_apk"
										multiple
										onChange={this.onFileSelect}/>
									<label className="custom-file-label" id="upload_apk_label" htmlFor="upload_apk">{this.state.uploadApkName}</label>
								</div>
							</FormGroup>
							<FormGroup className="upload modal-buttons">
								<Media
									className={!this.state.isApkUpload ?
										'modal-buttons__download visually-hidden' : 'modal-buttons__download'}
									object
									src={spinner}
									alt="upload spinner"
								/>
								<span className={!this.state.isApkUpload && Number.parseInt(this.props.progressPercent) < 1 ? 'modal-buttons__progress visually-hidden' : 'modal-buttons__progress'}>
									{this.props.progressPercent} %
								</span>
								<Button
									color="primary"
									type="submit"
									className={this.state.isApkUpload ? 'invisible' : 'visible'}
								>
									{I18n[lang].downloadApk.submit}
								</Button>
								<Button color="secondary" className="ml-1" onClick={this.closeUploadModal}>{I18n[lang].downloadApk.cancel}</Button>
							</FormGroup>
							<div className="alert__comment">
								{this.state.uploadModal ? this.state.uploadMessage: ''}
								{this.state.uploadModal ? this.state.uploadComment :''}
							</div>
						</Form>

					</ModalBody>
				</Modal>
				<Modal className="checkedApps-modal" isOpen={this.state.selectedAppModal} toggle={this.toggleSelectedAppModal}>
					<ModalHeader toggle={this.toggleSelectedAppModal}>{I18n[lang].checkedAppsList.title}</ModalHeader>
					<ModalBody>
						<CheckedAppsList
							checkedApps={this.props.checkedAppsInfo}
							uncheckedApp={this.uncheckedApp}
							uncheckedAllApps={this.uncheckedAllApps}
							sendCheckedApps={this.sendCheckedApps}
						/>
					</ModalBody>
				</Modal>
				<Modal className="view-app-modal" isOpen={this.state.isOkViewAppModal} toggle={() => {this.isOkViewAppModalToggle(null)}}>
					<ModalHeader toggle={() => {this.isOkViewAppModalToggle(null)}}>{I18n[lang].application.title}</ModalHeader>
					<ModalBody>
						<Application
							activeAppId={this.state.activeAppId}
							view={MARKETVIEW.GLOBAL_MARKET}
							closeModal={() => {this.isOkViewAppModalToggle(null)}}
						/>
					</ModalBody>
				</Modal>
				<Card>
					<CardTitle className="market-title mb-0 p-3 border-bottom bg-light">
						<div>
							<i className="mdi mdi-border-right mr-2"></i>{I18n[lang].title}
						</div>
					</CardTitle>
					<div className="market-title__top">
						<Form className="market-title__searchform">
							<Input
								type="text"
								name="search"
								id="search"
								placeholder={I18n[lang].searchPlaceholder}
								onChange={this.onFilterClick}
							/>
						</Form>
						<div className="market-title__left">
							{
								(this.state.checkedApps.length) ?
									(<Button
											className="market-title__btn market-title__btn_checked btn btn-success"
											type="button"
											onClick={this.toggleSelectedAppModal}>
											<i className="ti-shopping-cart"></i>
											<span className="market-title__badge badge badge-secondary badge-pill">
											{this.state.checkedApps.length}
										</span>
											{I18n[lang].selected}
										</Button>
									) : (
										""
									)
							}
							{
								(this.props.authority === SUPER_ADMIN) ?
									(<Button color="primary" type="button" onClick={this.uploadApkClick}>{I18n[lang].downloadApk.title}</Button>
									) : (
										""
									)
							}
							{
								(this.props.authority === COMPANY_ADMIN) ?
									(<Button
											className="btn-sm"
											color="secondary"
											type="button"
											onClick={() => {this.props.changeLocation('/dashboard/retail')}}
										>
											{I18n[lang].companyMarket}
										</Button>
									) : (
										""
									)
							}
						</div>
					</div>
					{
						(() => {
							const { loading } = this.props;
							const apps = this.props.filteredApps || this.props.apps;
							if (loading) {
								return <CardBody className="market-list"><div className="loading">Loading...</div></CardBody>;
							} else {
								const generatedAppsList = this.generateAppsList(apps);
								return (
									<CardBody>
										<div className="market-list">
											{ generatedAppsList }
										</div>
										{/*<PaginationList*/}
											{/*totalPages={this.props.pagination.totalPages}*/}
											{/*currentPage={this.state.currentPage}*/}
											{/*paginatedList={this.state.paginatedList}*/}
											{/*setCurrentPage={this.setCurrentPage}*/}
											{/*setPaginatedList={this.setPaginatedList}*/}
										{/*/>*/}
										<Pagination
											isVisible={apps.length > PAGINATION_DEFAULT_LIMIT ? 'hide' : ''}
											onPageChange={this.onPageChange}
											pages={apps.length % PAGINATION_DEFAULT_LIMIT > 0 ?
												parseInt(apps.length / PAGINATION_DEFAULT_LIMIT) + 1 :
												parseInt(apps.length / PAGINATION_DEFAULT_LIMIT)}
											page={this.state.activePage}
											nextText={">>"}
											previousText={"<<"}
										/>
									</CardBody>
								)
							}
						})()
					}
				</Card>
			</div>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
		fetchApps: query => dispatch(fetchApps(query)),
		fetchCompanies: query => dispatch(fetchCompanies(query)),
		filteringApps: filterWord => dispatch(filteringApps(filterWord)),
		uploadNewApk: apk => dispatch(uploadNewApk(apk)),
		closeAlert: () => dispatch(closeAlert()),
		changeLocation: url => dispatch(push(url)),
		localGetSelectedApps: () => dispatch(localGetSelectedApps()),
		localSaveSelectedApps: checkedApps => dispatch(localSaveSelectedApps(checkedApps)),
		fetchCheckedAppsInfo: checkedApps => dispatch(fetchCheckedAppsInfo(checkedApps)),
		getInRetailAppsList: (companyId, checkedAppsPackageNames) => dispatch(getInRetailAppsList(companyId, checkedAppsPackageNames)),
		saveInRetailAppsList: (companyId, checkedAppsIds) => dispatch(saveInRetailAppsList(companyId, checkedAppsIds))
	};
};

const mapStateToProps = state => ({
	alert: state.alert,
	apps: state.appsList.apps,
	filteredApps: state.filteredAppsList.apps,
	authority:  state.currentUser.roles[0].authority || GUEST,
	pagination: state.appsList.pagination,
	loading: state.appsList.loading,
	checkedApps: state.checkedAppsList.checkedApps,
	checkedAppsInfo: state.checkedAppsListInfo.checkedAppsInfo,
	checkedAppsInfoLoading: state.checkedAppsListInfo.loading,
	inRetailAppsList: state.getInRetailAppsList.inRetailAppsList,
	company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
	userData: state.userData,
	progressPercent: state.getUploadProgress.progressPercent,
	lang: state.languageReducer.lang

});

export default connect(mapStateToProps, mapDispatchToProps)(Market)



// WEBPACK FOOTER //
// ./src/components/Market/Market.js